export const FilterSessionStorageKey = 'marketing_session_storage_filter_value';
export const FilterCondSessionStorageKey = 'marketing_session_storage_filter_cond';
export const ShortIdSessionStorageKey = 'marketing_session_storage_short_id';
export const CategoryLocalTipsKey = 'marketing_category_local_storage_tips';
